export const API_KEYS_EVENTS = {
    VIEW_API_KEYS_PAGE: 'view_api_keys_page',
    RECREATE_API_KEYS: 'api_key_recreated'
}

export const API_KEYS_EVENTS_PARAMS = {
    API_KEYS: 'api_keys',
    KEY_TYPE: 'key_type',
    SUBSECTION: 'subsection',
}